<template>
<div class="string box">
  {{ findable.value }}  
</div>  
</template>
<script>
export default {
  
  props: {
    findable: {
      type: Object,
      default: () => ({})
    }
  }

}
</script>